import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import locationApi from '../../../api/services/LocationApi'
import {
  fetchStatusIs,
  LocationConfig,
  RequestStatus,
} from '../../../api/types'
import AppSpinner from '../../../components/AppSpinner'
import MainLayout from '../../../shared/layout/main-layout/MainLayout'
import AppContext from '../../context'
import { setLocationConfig, setOrganizations } from '../../context/actions'
import NavbarContext from '../../navbar/context'
import {
  setIsBackButtonVisible,
  setIsCloseButtonVisible,
} from '../../navbar/context/action'
import OrganizationsView from './OrganizationsView'

export type OrganizationsParamsType = {
  locationCode: string
}

interface OrganizationsProps {
  a?: boolean
}

const Organizations = ({}: OrganizationsProps) => {
  const navigate = useNavigate()

  const { locationCode } = useParams<OrganizationsParamsType>()

  const { contextDispatch } = useContext(AppContext)
  const { contextDispatch: navbarContextDispatch } = useContext(NavbarContext)

  const [requestStatus, setRequestStatus] = useState<RequestStatus>(
    RequestStatus.Idle
  )
  const { idle, pending, fulfilled } = fetchStatusIs(requestStatus)

  useEffect(() => {
    setIsBackButtonVisible(navbarContextDispatch, false)
    setIsCloseButtonVisible(navbarContextDispatch, false)
  }, [])

  const fetch = useCallback(async () => {
    if (!locationCode) return

    setRequestStatus(RequestStatus.Pending)

    const result = await locationApi.getOrganizations(locationCode)

    if (result) {
      if (result.data.organizations.length === 0) {
        navigate('/blad')
      } else if (result.data.organizations.length === 1) {
        navigate(`${result.data.organizations[0].id}`)
      }
      setOrganizations(contextDispatch, result.data.organizations)

      const data: LocationConfig = {
        locationCode: locationCode,
        logoId: result.data.logoId,
        backgroundId: result.data.backgroundId,
      }
      setLocationConfig(contextDispatch, data)

      setRequestStatus(RequestStatus.Fulfilled)
    } else {
      setRequestStatus(RequestStatus.Rejected)
    }
  }, [contextDispatch])

  useEffect(() => {
    if (idle) fetch()
  }, [fetch, idle])

  return (
    <>
      <MainLayout withNavbar>
        <AppSpinner show={pending} />
        {fulfilled && <OrganizationsView />}
      </MainLayout>
    </>
  )
}

export default Organizations
